/**
 * Mulberry32 PRNG (compact state, reproducible streams).
 * @module game/belotArmenian/mulberry32
 */

/**
 * @param {number} seed
 * @returns {{ seed: number, mulberryA: number, draws: number }}
 */
function createRngMeta(seed) {
  const s = seed >>> 0;
  return { seed: s, mulberryA: s | 0, draws: 0 };
}

/**
 * @param {{ mulberryA: number, draws: number }} meta — mutates mulberryA, draws
 * @returns {number} in [0, 1)
 */
function rngDraw(meta) {
  let a = meta.mulberryA | 0;
  a = (a + 0x6d2b79f5) | 0;
  const t = Math.imul(a ^ (a >>> 15), 1 | a);
  const u = (t + Math.imul(t ^ (t + 7), 61 | t)) ^ t;
  meta.mulberryA = a;
  meta.draws += 1;
  return ((u ^ (u >>> 14)) >>> 0) / 4294967296;
}

/**
 * @param {{ mulberryA: number, draws: number }} meta
 * @returns {() => number}
 */
function rngFromMeta(meta) {
  return () => rngDraw(meta);
}

module.exports = {
  createRngMeta,
  rngDraw,
  rngFromMeta,
};
